import { Dropdown } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { subscriptionService } from "../../services/subscription.service";
import LogicContext from "../../Context/LogicContext";
import { useCallback, useEffect } from "react";
import { useState } from "react";
import { useContext } from "react";
import {GetSubMData,SetSubMData } from "../../store/subscriptionAtom";
import underscore from "underscore";
// import CsvDownload from "react-json-to-csv";
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { Grid } from "@mui/material";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { spinnerService } from "../../services/spinner.service";
import { MdSync } from "react-icons/md";
import { FaPlus } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";

import { useForm } from "react-hook-form";
import moment from "moment";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
const columns = [
  {
    title: 'ID',
    key: 'Subscription_Ref_No',
    dataIndex: 'Subscription_Ref_No',
  className: "text-primary",
  sorter: (a, b) => (a?.Subscription_Ref_No ?? '') - (b?.Subscription_Ref_No ?? '')
  },

  {
    title: 'Name',
    // key: 'id',
    dataIndex: 'Customer_Full_Name',
  className: "text-primary font-bold",
  sorter: (a, b) => (a?.Customer_Full_Name ?? '').localeCompare(b?.Customer_Full_Name ?? '')

  },
    
  {
    title: "Mobile",
    dataIndex: "Customer_Mobile_No",
    sorter: (a, b) => (a?.Customer_Mobile_No ?? '').localeCompare(b?.Customer_Mobile_No ?? '')

  },

  {
    title: "Subscription",
    dataIndex: "Client_Subscription_No",
  sorter: (a, b) => (a?.Client_Subscription_No ?? '') - (b?.Client_Subscription_No ?? '')
  },

  {
    title: "Subscription No",
    dataIndex: "Subscription_No",
    sorter: (a, b) => (a?.Subscription_No ?? '').localeCompare(b?.Subscription_No ?? '')
  },
  {
    title: "Created On",
    dataIndex: "Subscription_Created_Date_String",
    sorter: (a, b) => (a?.Subscription_Created_Date_String ?? '').localeCompare(b?.Subscription_Created_Date_String ?? '')

  },
  {
    title: "Type",
    dataIndex: "Recuring_Description",
    sorter: (a, b) => (a?.Recuring_Description ?? '').localeCompare(b?.Recuring_Description ?? '')
  },
  
  {
    title: "Last Billing Date",
    dataIndex: "Last_Billed_Date_String",
    sorter: (a, b) => (a?.Last_Billed_Date_String ?? '').localeCompare(b?.Last_Billed_Date_String ?? '')
  },
  {
    title: "Next Billing Date",
    dataIndex: "Next_Billed_Date_String",
    sorter: (a, b) => (a?.Next_Billed_Date_String ?? '').localeCompare(b?.Next_Billed_Date_String ?? '')
  },
  {
    title: "Amount",
    dataIndex: "Total_Subscription_Amount",
  sorter: (a, b) => (a?.Total_Subscription_Amount ?? '') - (b?.Total_Subscription_Amount ?? ''),
    render: (record) => <span className="font-bold">
    {formatCustomNumber(record)}
  </span>,
  

  },
  
  {
    title: 'Status',
    dataIndex: 'Subscription_Status_Name',
    sorter: (a, b) => (a?.Subscription_Status_Name ?? '').localeCompare(b?.Subscription_Status_Name ?? ''),
    render: (record) => <span className={`${record === 'Live' ? 'text-green-500 font-bold' : record === 'Resend' ? 'text-yellow-500 font-bold' : ''}`}>
    {record}
  </span>,
  },
];


function SubscriptionPage() {
  const logicContext = useContext(LogicContext);
    const setSubData = SetSubMData();
    const getSubData = GetSubMData();
      const navigate = useNavigate();
      const { pathname } = useLocation();
      var url = pathname.split("/");
      const currModuleId = url[1];
      const currModuleName = url[2];
      const currUserMenu = url[3];
  
  const myPromiseModal = createModal(GeneralModal);

  const [itemSelected, setItemSelected] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [bulkActionData, setBulkActionData] = useState([]);
  const { register, getValues, formState: { errors }} = useForm();


  useEffect(() => {
    document.title ="Subscription"
    if (sessionStorage.getItem("reloadPage") === "true") {
      sessionStorage.removeItem("reloadPage");
      loadSubscription();
    }
  }, []);

  console.log('DOO ', getSubData);

  useEffect(() => {
    let isMounted = true;
    if (getSubData.subscription_info?.length) {
      setTableData(getSubData.subscription_info);
    } else {
      loadSubscription(isMounted);
    }

    return () => {
      isMounted = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadSubscription = (isMounted) => {
    subscriptionService.getSubList().then((res) => {
      const apiData = res?.data;
      if (apiData?.subscription_info?.length && isMounted) {
        setTableData(apiData?.subscription_info);
      }
      if (res?.data && isMounted) {
        setSubData(res?.data);
      }
    });
  };

     // Searches for manual journals by date range.
      const searchByDate = async (event) => {
        const formData = getValues();
        const response = await subscriptionService.subscriptionByDate(formData);
        if(response?.data?.length){
          setTableData(response.data);
        }else{
          setTableData([]);
          logicContext.showToast(
            "No available record for your search query!",
            ""
          );
        }
      };
    



  function customFilter(code) {
    

    if(code === 0){
    // back to default
      setTableData(getSubData?.subscription_info);

    }else{
      const activeList = getSubData?.subscription_info.filter(
        (sub) => sub.Subscription_Status_Id === code
      );
      setTableData(activeList);
    }
 
  }

  function selectedTableItems(itemList) {
    setItemSelected(itemList);
  }

  const resetSelectedItems = () => {
    setItemSelected([]);
  };

  async function bulkActions(masterOption) {
    await myPromiseModal({ title: masterOption?.Name,
      body: `Do you want to set ${masterOption?.Name} for selected items?`,
      showInput: false, placeHolder: "" }).then((result) => {
      if (result.decision === true) {
        var xmlString = "";
        itemSelected?.map((sub, i) => {
          xmlString += `<refno>${sub.Subscription_Ref_No} </refno>`;
        });

        subscriptionService.submitBulkAction({
            option: masterOption.Parent_Name1,
            xml_string_subs: `<root><a> ${xmlString} </a> </root>`,
          })
          .then((res) => {
            const { message_text, message_id } = res?.data[0];
            if (res.data !== undefined && Number(message_id) === 1) {
              loadSubscription();
              logicContext.showToast(message_text, "success");
            } else {
              logicContext.showToast("Error processing request!", "error");
            }
          });
      }
    });
  }

  function deleteItems() {
    // var xmlString = "";
    // itemSelect?.map((item) => {xmlString += `<a><refno>${item.Item_Id} </refno></a>`;
    // });
    // itemsService.deleteItems(`<root> ${xmlString} </root>`)
    //   .then((res) => {
    //     loadItemsFromServer();
    //   })
    //   .catch((err) => console.log("err ", err));
  }


  const paginationOptions = {
    pageSize: 10,
    showSizeChanger: true,
    total: tableData.length,
  };


  function handleRowClick(sub) {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${sub?.Subscription_Ref_No}`
    );
  }


  return (
    <>
      {itemSelected?.length > 0 ? (
        <div className="flex flex-row items-center justify-between">
          <div className="">
            <Dropdown className="relative w-full max-w-xs">
              <Dropdown.Toggle
                className="w-full !py-0 flex justify-between items-center !bg-gray-300 !text-gray-700 border-[1px] border-gray-400 focus:border-transparent active:border-transparent text-xs font-medium px-4 rounded-md hover:bg-gray-50 hover:border-transparent focus:text-gray-600 active:text-gray-600 hover:!text-gray-600 !ring-0 focus:!ring-0 active:!ring-0 focus:outline-none"
                id="dropdown-basic"
              >
                Bulk Actions
              </Dropdown.Toggle>

              <Dropdown.Menu className="w-[220px] max-h-80 overflow-y-auto mt-1 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 text-sm text-gray-700">
                {bulkActionData?.map((option, i) => {
                  return (
                    <Dropdown.Item
                      key={i}
                      onClick={() => bulkActions(option)}
                      className="pl-3 pr-2 py-2 hover:bg-gray-100 transition text-xs font-medium text-gray-600 truncate max-w-[200px]"
                    >
                      {option?.Name}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="text-center">
            <button onClick={resetSelectedItems} className="btn btn-danger">
              <IoClose className="h-4 w-4" />
            </button>
          </div>
        </div>
      ) : (
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-row items-center">
            <div className="">
              <Dropdown className="relative w-full max-w-xs">
                <Dropdown.Toggle
                  className="w-full !py-0 flex justify-between items-center !bg-gray-300 !text-gray-700 border-[1px] border-gray-400 focus:border-transparent active:border-transparent text-xs font-medium px-4 rounded-md hover:bg-gray-50 hover:border-transparent focus:text-gray-600 active:text-gray-600 hover:!text-gray-600 !ring-0 focus:!ring-0 active:!ring-0 focus:outline-none"
                  id="dropdown-basic"
                >
                  FILTER BY
                </Dropdown.Toggle>

                <Dropdown.Menu className="w-[220px] max-h-80 overflow-y-auto mt-1 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 text-sm text-gray-700">
              
                  {getSubData?.subscription_filter?.map((f)=> {
                    return (
                      <>

                  <Dropdown.Item
                    title="Active"
                    className="pl-3 pr-2 py-2 hover:bg-gray-100 transition text-xs font-medium text-gray-600 truncate max-w-[200px]"
                    onClick={() => customFilter(f?.Subscription_Filter_Id)}
                  >
                    {f?.Subscription_Filter_Name}
                  </Dropdown.Item>
                      </>
                    )
                  })}


                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="flex items-center gap-4">
              {/* Reload Button */}
              <Tooltip title="Reload">
                <RestartAlt
                  className="cursor-pointer text-blue-600 hover:text-blue-800 transition-colors self-center"
                  onClick={() => loadSubscription()}
                  color="primary"
                  fontSize="large"
                />
              </Tooltip>
        
              {/* Date Range Search */}
              <div className="flex items-center gap-3">
               <div className="flex flex-col mb-3">
                       <label className="text-sm font-medium text-gray-700">From Date</label>
                       <input
                         defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                         {...register("from_date")}
                         type="date"
                         className="h-10 w-80  bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                       />
                     </div>
                <div className="flex flex-col mb-3">
                      <label className="text-sm font-medium text-gray-700">To Date</label>
                      <input
                        defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                        {...register("to_date")}
                        type="date"
                        className="h-10 w-80  bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                      />
                    </div>
            
                <button
                  onClick={() => searchByDate()}
                  type="button"
                  className="mt-1 h-10 bg-blue-600 text-white text-sm font-medium rounded-md px-4 py-2 hover:bg-blue-700 transition-colors"
                >
                  Search
                </button>
              </div>
            </div>
          {/* end date search */}
          </div>

          <div className="flex flex-row items-center space-x-2">
            {/* <button
              style={{ color: "#476ef8" }}
              className="  rounded  text-md font-[Poppins] py-2 mt-1  px-3"
            >
              Import
            </button> */}
            {/* 
            <button
              style={{ color: "#476ef8" }}
              className=" mx-2 rounded  text-md font-[Poppins] mt-1 py-[1.8vh]  px-3"
            >
              Export
            </button> */}

            <Link
              to={`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`}
            >
              {" "}
              <Tooltip title="ADD NEW">
                <button
                  className="flex items-center justify-center p-2 rounded-md border border-gray-300 bg-white text-gray-600 hover:!bg-gray-100 active:!bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-gray-300 transition"
                  title="Add"
                >
                  <FaPlus className="h-4 w-4" />
                </button>
              </Tooltip>
            </Link>
          </div>
        </div>
      )}

   

          <section className="mt-5">
        <GeneralCustomTable
              tableHeadList={columns} 
              tableDataList={tableData}
            allowCheckBox={true} // show checkBox for each row
            setSelectedRows={selectedTableItems}
            paginationOptions={paginationOptions} 
            rowKey={(record) => record.Subscription_Ref_No} // custom key
            handleRowClick={handleRowClick} />
        </section>
    </>
  );
}

export default SubscriptionPage;
